<template>
  <v-container>
    <v-row justify="center" class="my-2">
      <v-col lg="2" class="d-flex justify-center">
        <v-img :src="$user.picture.large" max-width="100" contain class="rounded-circle"></v-img>
      </v-col>
      <v-col lg="10"> 
        <h1>{{$user.name.first + ' ' + $user.name.last}}</h1>
        <p>{{$user.location.country}}</p>
        <p class="my-n4">Age: {{$user.dob.age}}</p>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <h1 class="light-green--text">Confirmed events</h1>
    <v-container>
      <JoinedEvent v-for="event in $user.joinedEvents" v-bind:key="event.id" :event="event"/>
    </v-container>
  </v-container>
</template>

<script>

import JoinedEvent from '../components/JoinedEvent'

export default {
  name:'Profile',
  components:{
    JoinedEvent
  },
}
</script>

<style>

</style>